/**
 * Paginated RMA data table for the redesigned Manage Returns list: headers, sort, rows, and pagination.
 */
import { observer } from "mobx-react";
import { useCallback } from "react";
import Table from "../../../../../components/table/table";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import rmaPagedListStore from "../../stores/rma-tabs-paged-list-store";
import RmaListItemStore from "../../../rma-list-page/stores/rma-item-store";
import RmaListTableRow from "../rma-list-table-row/rma-list-table-row";
import "./rma-list-table.scss";

const RmaListTable: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const rmaListFiltersStore = rmaPagedListStore.rmaListFiltersStore;
    const isLoading =
        rmaPagedListStore.isLoading || rmaListFiltersStore.isLoading;

    const onPaginationSetPage = useCallback(async (page: number) => {
        rmaPagedListStore.resetIsLoaded();
        window.scrollTo(0, 0);
        await rmaPagedListStore.loadPage(page);
    }, []);

    const onSortPagedList = useCallback(
        (by: string, dir: string) => {
            if (by === "date_to_show") {
                rmsMixpanelStore.trackEvent("d&_date_column");
            }
            rmaPagedListStore.resetIsLoaded();
            rmaPagedListStore.sortData(by, dir);
        },
        [],
    );

    return (
        <div className="rma-list-table">
            <div className="rma-list-table__inner rma-table">
                <Table
                    isLoading={isLoading}
                    totalResultsTitle="returns"
                    pagination={{
                        onSetPage: onPaginationSetPage,
                        page: rmaPagedListStore.page,
                        total: rmaPagedListStore.total,
                        perPage: rmaPagedListStore.perPage,
                    }}
                    sort={{
                        onSort: onSortPagedList,
                        by: rmaPagedListStore.sortBy,
                        dir: rmaPagedListStore.sortDir,
                    }}
                    columns={[
                        {
                            content: getTranslation("RMA_DETAILS_COLUMN_HEADER", scope),
                            width: { value: 220, type: "px" },
                            sortable: true,
                            sortBy: "date_to_show",
                        },
                        { content: getTranslation("RESOLUTIONS", scope), width: { value: 1.8, type: "fr" } },
                        { content: getTranslation("ITEMS", scope), width: { value: 160, type: "px" } },
                        { content: getTranslation("CUSTOMER", scope), width: { value: 1, type: "fr" } },
                        { content: getTranslation("STATUS", scope), width: { value: 1.2, type: "fr" } },
                    ]}
                >
                    {rmaPagedListStore.list.map((rma: RmaListItemStore) => (
                        <RmaListTableRow key={rma.rmaId} rma={rma} />
                    ))}
                </Table>
            </div>
        </div>
    );
});

export default RmaListTable;
